export type Restzeit =
  | { status: 'vorher'; tage: number; stunden: number; minuten: number; sekunden: number }
  | { status: 'live' }
  | { status: 'vorbei' }

/** Zeit bis Sendebeginn fuer den Countdown im Aufmacher. */
export function restzeit(beginnUtc: string, endeUtc: string, jetzt = new Date()): Restzeit {
  const t = jetzt.getTime()
  if (t >= Date.parse(endeUtc)) return { status: 'vorbei' }
  if (t >= Date.parse(beginnUtc)) return { status: 'live' }
  let s = Math.floor((Date.parse(beginnUtc) - t) / 1000)
  const tage = Math.floor(s / 86_400)
  s -= tage * 86_400
  const stunden = Math.floor(s / 3600)
  s -= stunden * 3600
  const minuten = Math.floor(s / 60)
  return { tage, stunden, minuten, status: 'vorher', sekunden: s - minuten * 60 }
}
